module.exports = __webpack_public_path__ + "static/media/download.34797693.svg";